import { IBusinessUnitResult } from "../models"
import { LocalStorageKeys } from "./local-storage-keys"

export enum Languages {
  FR = "fr",
  IT = "it",
  ES = "es",
  NL = "nl",
  EN = "en",
}

export const languageOptions = [
  {
    key: Languages.FR,
    text: "Français",
    value: Languages.FR,
  },
  {
    key: Languages.IT,
    text: "Italian",
    value: Languages.IT,
  },
  {
    key: Languages.ES,
    text: "Español",
    value: Languages.ES,
  },
  {
    key: Languages.NL,
    text: "Nederlands",
    value: Languages.NL,
  },
  {
    key: Languages.EN,
    text: "English",
    value: Languages.EN,
  },
]

export const languages: Languages[] = languageOptions.map(
  (option) => option.key
)

export const getlangFromCache = (): Languages => {
  const lang: any =
    window.localStorage.getItem(LocalStorageKeys.LANG) || getLangFromNavigator()
  if (Object.values(Languages).includes(lang)) {
    return lang as Languages
  } else {
    return Languages.FR
  }
}

export const changeBu = (bu: IBusinessUnitResult | null) =>
  window.localStorage.setItem(LocalStorageKeys.SOCIETEG, JSON.stringify(bu))

export const getBuFromCache = (): IBusinessUnitResult | null => {
  const bu = window.localStorage.getItem(LocalStorageKeys.SOCIETEG)
  if (bu) {
    return JSON.parse(bu) as IBusinessUnitResult
  } else {
    return null
  }
}

export const changeLang = (lang: string) =>
  window.localStorage.setItem(LocalStorageKeys.LANG, lang)

const getLangFromNavigator = () => {
  let lang = window.navigator.language.slice(0, 2)
  lang = lang === "en" ? "gb" : lang

  const langExists = !!languageOptions.find((l) => l.key === lang)
  if (!langExists) {
    lang = "fr"
  }

  window.localStorage.setItem(LocalStorageKeys.LANG, lang)
  return lang
}
